import React, { useContext } from "react";
// Libraries
import { PropTypes } from "prop-types";
import MaterialTable from "material-table";
import tableDefaultConfiguration from "./MainTableConfiguration";
// Actions
import { ErrorContext } from "../../../Contexts/ErrorContext";

const defaultDeleteText = "¿Está seguro que desea borrar?";

const errorValidator = (newData, requiredFields, columns) => {
  let errorMessage = "Falta completar: ";
  let hasError = false;
  requiredFields.forEach((requiredField) => {
    if (!newData.hasOwnProperty(requiredField)) {
      hasError = true;
      const column = columns.find((column) => column.field === requiredField);
      const spanishWord = !column ? requiredField : column.title;
      errorMessage = errorMessage.concat(`${spanishWord}, `);
    }
  });
  errorMessage = errorMessage.slice(0, errorMessage.length - 2);
  return { errorMessage, hasError };
};

const MainTable = (props) => {
  const {
    title,
    columns,
    data,
    onRowAdd,
    onRowUpdate,
    onRowDelete,
    actions,
    deleteText,
    requiredFields,
    isDeletable,
    options,
    editRequiredFiles,
    isAddAllowed = true,
    isUpdateAllowed = true,
    isDeleteAllowed = true,
    rowStyle = null,
  } = props;

  tableDefaultConfiguration.localization.body.editRow.deleteText = `${defaultDeleteText} ${deleteText}`;

  const centeredColumns =  columns.map(column => {
    return {...column, cellStyle: { textAlign: "center" }, headerStyle: { textAlign: 'center' }}
  })

  const editable = {}
  if (isAddAllowed) {
    editable.onRowAdd = (newData) =>
      new Promise((res, rej) => {
        const { errorMessage, hasError } = errorValidator(
          newData,
          requiredFields,
          centeredColumns
        );
        if (hasError) {
          setError(errorMessage);
          rej();
          return;
        }
        onRowAdd(newData).then(res).catch(rej);
      })
  }
  if (isUpdateAllowed) {
    editable.onRowUpdate = (newData) =>
      new Promise((res, rej) => {
        const { errorMessage, hasError } = errorValidator(
          newData,
          ["id", ...(editRequiredFiles || requiredFields)],
          centeredColumns
        );
        if (hasError) {
          setError(errorMessage);
          rej();
          return;
        }
        onRowUpdate(newData).then(res).catch(rej);
      })
  }

  if (isDeleteAllowed) {
    editable.onRowDelete = (newData) =>
      new Promise((res, rej) => {
        const { errorMessage, hasError } = errorValidator(
          newData,
          ["id"],
          centeredColumns
        );
        if (hasError) {
          setError(errorMessage);
          rej();
          return;
        }
        onRowDelete(newData).then(res).catch(rej);
      })
  }

  editable.isDeletable = isDeletable

  const { setError } = useContext(ErrorContext);
  return (
    <MaterialTable
      {...{
        ...tableDefaultConfiguration,
        title,
        columns: centeredColumns,
        data,
        options: {
          addRowPosition: "first",
          rowStyle,
          ...options,
        },
        actions,
      }}
      editable={editable}
    />
  );
};

MainTable.propTypes = {
  title: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      field: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  data: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  onRowAdd: PropTypes.func.isRequired,
  onRowUpdate: PropTypes.func.isRequired,
  onRowDelete: PropTypes.func.isRequired,
  actions: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        icon: PropTypes.any.isRequired,
        tooltip: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
      }).isRequired,
      PropTypes.func.isRequired
    ])
  ),
  deleteText: PropTypes.string.isRequired,
  requiredFields: PropTypes.arrayOf(PropTypes.string),
  editRequiredFiles: PropTypes.arrayOf(PropTypes.string),
  isDeletable: PropTypes.func,
};

export default MainTable;



// WEBPACK FOOTER //
// ./src/Components/Tables/Main/MainTable.js